module.exports = __webpack_public_path__ + "src/app/venue/parkMap/assets/dim.png?5312e2e05dd92ee8386c19a5eb912801";